import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const ZipPerdeTentePage = () => {
  useEffect(() => {
    document.title = 'Zip Perde Tente Tamiri - İzmir Tente Tamir | Profesyonel Tamir Hizmeti';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde profesyonel zip perde tente tamiri hizmeti. Fermuarlı sistem arızaları, ray mekanizma ve branda değişimi. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Şeffaf Stor Tente', link: '/hizmetler/seffaf-stor-tente' },
    { title: 'T-Modül Tente', link: '/hizmetler/t-modul-tente' },
    { title: 'Kasetli Tente Tamiri', link: '/hizmetler/kasetli-tente' },
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      {/* Hero Image Section */}
      <div className="w-full h-64 md:h-96 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/651a3796e26a6ef2e1eeee905d95ccc4.jpg"
          alt="Zip Perde Tente"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Zip Perde Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Zip Perde Tente Tamiri
              </h1>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Zip perde sistemleri, fermuarlı kenar yapısı sayesinde rüzgara karşı maksimum dayanıklılık sağlayan modern gölgeleme çözümleridir. Özellikle rüzgarlı bölgelerde tercih edilen bu sistemler, hem estetik hem de fonksiyonel avantajlar sunar. İzmir Tente Tamir olarak, zip perde sistemlerinin tüm arızalarına profesyonel çözümler sunuyoruz.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Zip Perde Tente Nedir?</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Zip perde, brandanın kenarlarında bulunan fermuarlı sistem sayesinde yan profillere sıkıca tutunduğu dikey gölgeleme sistemidir. Bu özellik sayesinde rüzgarda sallanma olmaz ve branda her zaman gergin kalır. Hem dikey hem yatay kullanılabilir. Manuel veya motorlu olarak üretilebilir. Cam balkonlar, teraslar, kış bahçeleri ve ticari mekanlar için ideal çözümdür.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Zip Perde Tamiri Kapsamı</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Zip perde sistemlerinde karşılaşılan sorunlar ve tamir hizmetlerimiz:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Fermuarlı Kenar Arızaları:</strong> Zip sistemindeki kopma, sıkışma ve çıkma sorunlarını gideriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Ray Mekanizma Tamiri:</strong> Yan profillerdeki ray sistemindeki sorunları çözüyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Branda Değişimi:</strong> Yıpranan veya hasar gören brandaları yenisiyle değiştiriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Motor ve Kumanda:</strong> Motorlu sistemlerdeki elektriksel ve mekanik arızaları onarıyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Profil ve Bağlantı:</strong> Alüminyum profillerdeki hasar ve montaj sorunlarını düzeltiyoruz.</span>
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Tamir Süreci</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">1. Detaylı İnceleme</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Uzman ekibimiz, zip perde sisteminizi yerinde detaylı olarak inceler. Fermuarlı kenar sistemi, ray mekanizması, branda durumu ve motor kontrol edilir. Arızanın kaynağı tespit edilerek size rapor edilir.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">2. Çözüm Önerisi ve Fiyatlandırma</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                İnceleme sonrasında, yapılması gereken işlemler ve kullanılacak malzemeler hakkında bilgilendirme yapılır. Şeffaf ve net fiyat teklifi sunulur.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">3. Profesyonel Tamir</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Onayınızın ardından, orijinal veya eşdeğer kalitede yedek parçalar kullanılarak tamir işlemi gerçekleştirilir. Zip sistemi özel dikkat gerektirdiğinden deneyimli teknisyenlerimiz tarafından titizlikle yapılır.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">4. Test ve Ayarlama</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Tamir sonrasında sistem kapsamlı testlerden geçirilir. Zip sisteminin düzgün çalışması, brandanın gerginliği ve genel işlevsellik kontrol edilir. Sorunsuz çalıştığından emin olunduktan sonra size teslim edilir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Zip Perde Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Rüzgar Dayanımı:</strong> Fermuarlı sistem sayesinde güçlü rüzgarlara karşı dayanıklıdır.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Işık Kontrolü:</strong> Branda her zaman gergin olduğu için ışık geçişi kontrollüdür.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Estetik Görünüm:</strong> Düz ve gergin yüzeyi ile modern ve şık görünüm sağlar.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Sessiz Çalışma:</strong> Rüzgarda sallanma olmadığı için sessiz kullanım sunar.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Uzun Ömürlü:</strong> Kaliteli malzeme ve sistem ile yıllarca sorunsuz kullanım.</span>
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Bakım Önerileri</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Zip perde sisteminizin uzun ömürlü olması için düzenli bakım önemlidir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Yan profillerdeki rayları düzenli olarak temizleyin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Brandayı mevsimde bir kez yumuşak fırça ile temizleyin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Zip sistemini zorlamadan kullanın, sıkışma durumunda profesyonel yardım alın</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Yılda bir kez profesyonel bakım hizmeti alın</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-8 mt-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-gray-700 mb-6">
                  Zip perde tamiriniz için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-6 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ZipPerdeTentePage;
